import script from "./SocialFundRequestActionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundRequestActionDialog.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundRequestActionDialog.vue?vue&type=style&index=0&id=0efd47fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0efd47fa"]])

export default __exports__